import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { Form, Button, InputGroup, Spinner, Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { API_URL } from '../../../config'; // Adjust the path as needed
import { useAppData } from '../AppDataContext';

const ProductListingForm = ({ formValues, setFormValues }) => {
    const [availableProducts, setAvailableProducts] = useState([]);
    const [loadingProducts, setLoadingProducts] = useState(true);
    const [error, setError] = useState(null);
    const { subdomain } = useAppData();

    // Fetch available products from the API on component mount
    useEffect(() => {
        const fetchAvailableProducts = async () => {
            try {
                const response = await fetch(`${API_URL}/products?account_key=${subdomain}`);
                const data = await response.json();

                if (response.ok && data.success) {
                    setAvailableProducts(data.products);
                } else {
                    throw new Error(data.message || 'Failed to fetch products.');
                }
            } catch (err) {
                console.error('Error fetching products:', err);
                setError(err.message);
            } finally {
                setLoadingProducts(false);
            }
        };

        fetchAvailableProducts();
    }, []);


    const productOptions = availableProducts.map(product => ({
        value: product.product_id,
        label: product.product_name,
    }));

    // Handle changes in the product selection
    const handleSelectChange = (selectedOptions) => {
        if (selectedOptions.length > 12) {
            selectedOptions = selectedOptions.slice(0, 2);
        }
        setFormValues({
            ...formValues,
            selectedProducts: selectedOptions.map(option => ({
                value: option.value,
                label: option.label,
            })),
        });
    };

    // Handle removing a product
    const handleRemoveProduct = (index) => {
        const updatedProducts = [...formValues.selectedProducts];
        updatedProducts.splice(index, 1);
        setFormValues({ ...formValues, selectedProducts: updatedProducts });
    };


    return (
        <div className="product-listing-form">
            {error && (
                <Alert variant="danger" onClose={() => setError(null)} dismissible>
                    {error}
                </Alert>
            )}

            {/* Product Selection */}
            <Form.Group controlId="selectedProducts">
                <Form.Label>Select Products (Maximum 12)</Form.Label>
                {loadingProducts ? (
                    <Spinner animation="border" role="status" />
                ) : (
                    <Select
                        isMulti
                        options={productOptions}
                        value={formValues.selectedProducts || []}
                        onChange={handleSelectChange}
                        placeholder="Select up to 12 products..."
                        closeMenuOnSelect={false}
                        maxMenuHeight={200}
                        isOptionDisabled={() =>
                            (formValues.selectedProducts || []).length >= 12
                        }
                    />
                )}
            </Form.Group>

            {/* Display Selected Products */}
            {formValues.selectedProducts?.length > 0 && (
                <div className="selected-products mt-3">
                    <h5>Selected Products:</h5>
                    {formValues.selectedProducts.map((product, index) => (
                        <InputGroup key={product.value} className="mb-2">
                            <Form.Control type="text" readOnly value={product.label} />
                            <Button
                                variant="danger"
                                onClick={() => handleRemoveProduct(index)}
                            >
                                <FontAwesomeIcon icon={faTrash} />
                            </Button>
                        </InputGroup>
                    ))}
                </div>
            )}
        </div>
    );
};

export default ProductListingForm;
